import {useParams} from "react-router-dom";

export default () => {
  const params = useParams();
  return params?.showId as string;
};
